import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Lock, Mail, Loader2 } from 'lucide-react'
import { useAuth } from '../contexts/AuthContext'

export default function Login() {
  const [email, setEmail]     = useState('')
  const [password, setPass]   = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError]     = useState('')
  const { login } = useAuth()
  const navigate  = useNavigate()

  async function onSubmit() {
    setError('')
    if (!email || !password) { setError('Ingresa tu correo y contraseña.'); return }
    setLoading(true)
    const { error } = await login(email, password)
    setLoading(false)
    if (error) { setError('Correo o contraseña incorrectos.'); return }
    navigate('/chatbot', { replace: true })
  }

  function onKey(e) { if (e.key === 'Enter') onSubmit() }

  return (
    <main style={{ display: 'grid', minHeight: '100vh', placeItems: 'center', padding: '0 20px' }}>
      <div style={{ width: '100%', maxWidth: 400 }}>

        {/* Logo */}
        <div style={{ marginBottom: 32, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <img src="/logo.png" alt="Centro de Arbitraje CCIA"
            style={{ width: 240, height: 'auto' }} />
          <p style={{ marginTop: 20, fontSize: 13, color: 'var(--ash-500)' }}>
            Panel de gestión · acceso restringido
          </p>
        </div>

        {/* Card */}
        <div className="panel" style={{ padding: 28 }}>
          <h1 className="font-display" style={{ fontSize: 18, fontWeight: 600, color: '#fff' }}>
            Iniciar sesión
          </h1>
          <p style={{ marginTop: 4, fontSize: 13, color: 'var(--ash-500)' }}>
            Usa las credenciales que te asignó el administrador.
          </p>

          <div style={{ marginTop: 24, display: 'flex', flexDirection: 'column', gap: 16 }}>
            {/* Email */}
            <div>
              <label className="label">Correo</label>
              <div style={{ position: 'relative' }}>
                <Mail size={15} style={{ position: 'absolute', left: 12, top: 11, color: 'var(--ash-600)', pointerEvents: 'none' }} />
                <input className="input" type="email" autoComplete="email"
                  placeholder="tu@arbitrajeccia.com.pe"
                  style={{ paddingLeft: 36 }}
                  value={email} onChange={e => setEmail(e.target.value)} onKeyDown={onKey} />
              </div>
            </div>

            {/* Password */}
            <div>
              <label className="label">Contraseña</label>
              <div style={{ position: 'relative' }}>
                <Lock size={15} style={{ position: 'absolute', left: 12, top: 11, color: 'var(--ash-600)', pointerEvents: 'none' }} />
                <input className="input" type="password" autoComplete="current-password"
                  placeholder="••••••••"
                  style={{ paddingLeft: 36 }}
                  value={password} onChange={e => setPass(e.target.value)} onKeyDown={onKey} />
              </div>
            </div>

            {/* Error */}
            {error && (
              <div style={{
                borderRadius: 8, border: '1px solid rgba(193,39,45,.4)',
                background: 'rgba(193,39,45,.1)', padding: '8px 12px',
                fontSize: 13, color: '#E03546',
              }}>
                {error}
              </div>
            )}

            {/* Submit */}
            <button className="btn btn-primary" onClick={onSubmit} disabled={loading}
              style={{ width: '100%' }}>
              {loading
                ? <Loader2 size={16} className="animate-spin" />
                : <Lock size={16} />
              }
              {loading ? 'Verificando…' : 'Entrar'}
            </button>
          </div>
        </div>

        <p style={{ marginTop: 24, textAlign: 'center', fontSize: 11, color: 'var(--ash-600)' }}>
          Cámara de Comercio e Industria de Arequipa · 28 años
        </p>
      </div>
    </main>
  )
}
